import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift, Headphones, BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-cream-50 relative" data-id="element-107">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-terra-500 to-transparent opacity-30" data-id="element-108" />

      <div className="max-w-6xl mx-auto px-4" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-sm font-bold tracking-widest text-terra-500 uppercase mb-4" data-id="element-111">
            La Oferta de Prueba
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading text-brown-900 mb-6" data-id="element-112">
            The Intro Bundle
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-brown-800 max-w-2xl mx-auto" data-id="element-113">
            Queremos que pruebes este sistema hoy mismo sin riesgos. Por eso,
            hemos creado el{' '}
            <span className="text-terra-500 font-semibold" data-id="element-114">
              "Starter Pack de Alineación"
            </span>
            :
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-115">
          {/* Mockup Column */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-116">
            <div className="absolute inset-0 bg-terra-500/10 blur-[100px] rounded-full" data-id="element-117" />
            <img src="https://cdn.magicpatterns.com/uploads/ddb2wye3iqec33iSAyA62R/heylloyd-image-1774245714930.png" alt="Bundle El Código Celestial del Triunfo" className="w-full relative z-10 rounded-2xl shadow-2xl shadow-black/10" data-id="element-118" />
          </motion.div>

          {/* Details Column */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-terra-500/20 rounded-3xl p-8 md:p-10 box-glow-gold" data-id="element-119">
            <ul className="space-y-6 mb-10" data-id="element-120">
              <li className="flex items-start gap-4" data-id="element-121">
                <div className="p-2 bg-terra-500/10 rounded-lg shrink-0 mt-1" data-id="element-122">
                  <BookOpen className="w-6 h-6 text-terra-500" data-id="element-123" />
                </div>
                <div data-id="element-124">
                  <h4 className="text-xl font-bold text-brown-900 mb-1" data-id="element-125">
                    📘 Libro Digital
                  </h4>
                  <p className="text-brown-800" data-id="element-126">
                    "El Código Celestial del Triunfo" (Lectura rápida en 60
                    min).
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-127">
                <div className="p-2 bg-terra-500/10 rounded-lg shrink-0 mt-1" data-id="element-128">
                  <Headphones className="w-6 h-6 text-terra-500" data-id="element-129" />
                </div>
                <div data-id="element-130">
                  <h4 className="text-xl font-bold text-brown-900 mb-1" data-id="element-131">
                    🎧 Audiolibro Completo
                  </h4>
                  <p className="text-brown-800" data-id="element-132">
                    Narrado profesionalmente para que lo escuches en tu trayecto
                    al trabajo o en el gym.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-133">
                <div className="p-2 bg-terra-500/10 rounded-lg shrink-0 mt-1" data-id="element-134">
                  <Gift className="w-6 h-6 text-terra-500" data-id="element-135" />
                </div>
                <div data-id="element-136">
                  <h4 className="text-xl font-bold text-brown-900 mb-1" data-id="element-137">
                    🎁 BONUS EXCLUSIVO
                  </h4>
                  <p className="text-brown-800" data-id="element-138">
                    Guía de Oración para Negocios (Qué decir exactamente antes
                    de una reunión importante).
                  </p>
                </div>
              </li>
            </ul>

            <div className="border-t border-brown-900/10 pt-8 mb-8 text-center" data-id="element-139">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-140">
                <span className="text-gray-500 line-through text-xl" data-id="element-141">
                  Valor: $67
                </span>
                <span className="bg-red-500/10 text-red-600 px-3 py-1 rounded-full text-sm font-bold" data-id="element-142">
                  90% OFF HOY
                </span>
              </div>
              <div className="text-6xl font-heading font-bold text-terra-500 text-glow-gold" data-id="element-143">
                $6.70
              </div>
            </div>

            <div id="final-cta" data-id="element-144">
              <CTAButton fullWidth className="text-lg py-5" href="https://www.lanzadigital360.com/cart/48124684239073:1" onClick={trackAddToCart} data-id="element-145">
                SÍ, QUIERO LAS 5 REGLAS + EL AUDIOLIBRO
              </CTAButton>
            </div>

            <p className="text-center text-sm text-brown-700/60 mt-4 flex items-center justify-center gap-2" data-id="element-146">
              <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-147" />
              Acceso inmediato después del pago.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}